export default __webpack_public_path__ + "static/media/rec.609ed02f.svg";